import { useContext } from 'react';
import { Separator } from '../Separator';
import { NavbarContext } from './NavbarContext';

export const NavbarSeparator = () => {
  const { theme: navbarTheme } = useContext(NavbarContext);

  return (
    <div className="h-full mx-2.5">
      <Separator
        color={
          navbarTheme === 'dark' ? 'bg-ds-natural-500' : 'bg-ds-natural-150'
        }
      />
    </div>
  );
};
